import React from 'react';
import { Modal, ModalProps } from 'antd';
import styled from 'styled-components';
import { CloseCircleOutlined } from '@ant-design/icons';

const StyledModal = styled(Modal)`
  .modal-title {
    color: ${(props) => props.theme.color.primaryBase};
    ${(props) => props.theme.typo.familyGoogle.bold};
    font-size: 20px;
    margin-bottom: 15px;
    padding-right: 30px;
  }

  section {
    margin-bottom: 15px;
  }

  .ant-modal-body {
    padding: 24px 16px;

    @media screen and (min-width: 768px) {
      padding: 40px;
    }
  }

  .sub-title {
    ${(props) => props.theme.typo.familyGoogle.semiBold};
  }

  .modal-body {
    font-size: 12px;
    line-height: 18px;
  }

  ul {
    list-style: initial;
    li {
      color: ${(props) => props.theme.color.onSurface};
      ${(props) => props.theme.typo.familyGoogle.regular}
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .ant-modal-close-x {
    position: absolute;
    width: 21px;
    height: 21px;
    top: 24px;
    right: 16px;
    line-height: 0;

    @media screen and (min-width: 768px) {
      top: 40px;
      right: 40px;
    }

    .anticon-close-circle {
      font-size: 21px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
`;

export type MobileModalProps = ModalProps & {
  handleClose: () => void;
};

const CCPOFeaturesModal = ({ title, visible, handleClose, children }: MobileModalProps) => (
  <StyledModal visible={visible} onCancel={handleClose} footer={null} width={912} closeIcon={<CloseCircleOutlined />}>
    {title && <div className="modal-title">{title}</div>}
    {children}
  </StyledModal>
);

export default CCPOFeaturesModal;
